import { useLocale } from "@react-aria/i18n";
import { Bell, CalendarIcon, Clock4 } from "lucide-react";

export function LeftPanel({
	showForm,
	timeZone,
	slot,
	timeIntervalMinutes
}: {
	showForm: boolean | null;
	timeZone: string;
	slot?: string;
	timeIntervalMinutes?: number | string;
}) {
	const { locale } = useLocale();

	return (
		<div className="flex flex-col flex-1 w-full px-6 py-8 border-r ">
			<div className="grid">
				<h1 className="text-xl font-medium mb-4">Weight loss consultation</h1>
				{showForm && (
					<div className="flex flex-col gap-2 space-y-4">
						<div className="flex items-center">
							<CalendarIcon className="size-5 mr-2 text-[#7F8493]" />
							<p className="text-base font-medium text-[#26282F]">
								{new Date(slot as string).toLocaleDateString(locale, {
									weekday: 'long',
									month: 'short',
									day: 'numeric',
									year: 'numeric'
								})}
							</p>
						</div>
						<div className="flex items-center ">
							<Bell className="size-5 mr-2 text-[#7F8493]" />
							<p className=" text-base font-medium text-[#26282F]">
								{new Date(slot as string).toLocaleString(locale, {
									hour: '2-digit',
									minute: '2-digit',
									hour12: true
								})}
								{", "}
								{timeZone.replace(/_/g, " ").split("(")[0]?.trim()}
							</p>
						</div>
					</div>
				)}
				<div className="flex items-center mt-5">
					<Clock4 className="size-5 mr-2 text-[#7F8493]" />
					<p className="text-base font-medium text-[#26282F]">{timeIntervalMinutes} mins</p>
				</div>
			</div>
		</div>
	);
}
